export const PC_ID_MAX = 2147483647;

export const pcIdIsValid = (pcId: number) => Number.isInteger(pcId) && pcId >= 1 && pcId <= PC_ID_MAX;

export const pcIdValidationError = (pcId: number) => {
  if (pcIdIsValid(pcId)) {
    return null;
  }
  return pcId
    ? 'Número do computador inválido. Apague o campo "Informe o número do computador" e digite só o número, sem bipar código de barras.'
    : 'Informe o número do seu computador';
};
